import { cn } from "@/lib/utils";
import { AlertTriangle, Clock, CheckCircle2 } from "lucide-react";

function fmtRemaining(min) {
  if (min == null) return "";
  if (min <= 0) {
    const over = -min;
    if (over < 60) return `${over}m over`;
    return `${Math.floor(over / 60)}h ${over % 60}m over`;
  }
  if (min < 60) return `${min}m left`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${h}h ${m}m left`;
}

export function SLABadge({ status, remainingMin, className }) {
  if (!status || status === "n/a" || status === "done") return null;
  const map = {
    breached:  { label: "SLA BREACHED", icon: AlertTriangle, cls: "bg-red-500/15 text-red-400 border-red-500/40" },
    at_risk:   { label: "SLA AT RISK",  icon: Clock,         cls: "bg-orange-500/15 text-orange-400 border-orange-500/40" },
    on_track:  { label: "ON TRACK",     icon: CheckCircle2,  cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  };
  const m = map[status] || map.on_track;
  const Icon = m.icon;
  return (
    <span data-testid={`sla-badge-${status}`}
      className={cn("inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider", m.cls, className)}>
      <Icon className="h-3 w-3" />
      {m.label}
      {remainingMin != null && <span className="ml-1 font-mono font-medium opacity-80">· {fmtRemaining(remainingMin)}</span>}
    </span>
  );
}
